import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ConnectWithOurTeam from "./sections/ConnectWithOurTeam";
import OurLocation from "./sections/OurLocation";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <ConnectWithOurTeam />
      <OurLocation />
      <SiteFooter />
    </div>;
}